module.exports = __webpack_public_path__ + "img/profil_lapper_Giske.0b6bc84d.png";